import { render, staticRenderFns } from "./EntityLog.vue?vue&type=template&id=f2fce890&scoped=true&"
import script from "./EntityLog.vue?vue&type=script&lang=js&"
export * from "./EntityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fce890",
  null
  
)

export default component.exports